module.exports = __webpack_public_path__ + "ed73417933550f792a8b203fec0c1c42.MP3";